module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Stages")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "stagename"
    }
  }, [_vm._v("Stage Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stagename),
      expression: "stagename"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "stagename",
      "placeholder": "Name of the stage"
    },
    domProps: {
      "value": (_vm.stagename)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stagename = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "input-type"
    }
  }, [_vm._v("Input Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputType),
      expression: "inputType"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "input-type"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.inputType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setOptions]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--No input--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Number"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Boolean"
    }
  }, [_vm._v("Boolean")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Text"
    }
  }, [_vm._v("Text")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "options"
    }
  }, [_vm._v("Options")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options),
      expression: "options"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.inputType == 'Boolean',
      "id": "options",
      "placeholder": "Text input mapping, comma separated"
    },
    domProps: {
      "value": (_vm.options)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.options = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "next-stages"
    }
  }, [_vm._v("Next Stage(s)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nextStages),
      expression: "nextStages"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "next-stages",
      "placeholder": "Next stage(s); comma separated"
    },
    domProps: {
      "value": (_vm.nextStages)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nextStages = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Failed")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.failed),
      expression: "failed"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Next stage if there's an input failure"
    },
    domProps: {
      "value": (_vm.failed)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.failed = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Next App (if any)")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nextApp),
      expression: "nextApp"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "input-type"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.nextApp = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setOptions]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select app--")]), _vm._v(" "), _vm._l((_vm.allApps), function(each, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": each.value
      }
    }, [_vm._v(_vm._s(each.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Skip If")]), _vm._v(" "), _c('div', {
    staticClass: "two-fields"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.skip.type),
      expression: "skip.type"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.skip.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getPropertyKeys('skip', _vm.skip.type)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("No Property")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "account"
    }
  }, [_vm._v("Account")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "session"
    }
  }, [_vm._v("Session")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.skip.key),
      expression: "skip.key"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.skip.key = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("No Key")]), _vm._v(" "), _vm._l((_vm.propertyKeys.skip), function(each, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": each.value
      }
    }, [_vm._v(_vm._s(each.name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', [_vm._v("Notification")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notification),
      expression: "notification"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Notification to chatbot"
    },
    domProps: {
      "value": (_vm.notification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notification = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isScreening),
      expression: "isScreening"
    }]
  }, [_c('br', {
    attrs: {
      "clear": "all"
    }
  }), _c('br', {
    attrs: {
      "clear": "all"
    }
  }), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Methods Addition/Removal")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-3"
  }, [_c('label', [_vm._v("Option")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.methodOption),
      expression: "methodOption"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.methodOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Option--")]), _vm._v(" "), _vm._l((_vm.allOptions), function(each, index) {
    return _c('option', {
      key: index
    }, [_vm._v(_vm._s(each))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-4"
  }, [_c('label', [_vm._v("Action")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.methodTypeModification),
      expression: "methodTypeModification"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.methodTypeModification = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Action--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "add"
    }
  }, [_vm._v("Add Methods")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "remove"
    }
  }, [_vm._v("Remove Methods")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-4"
  }, [_c('label', [_vm._v("Methods")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.choosenMethods),
      expression: "choosenMethods"
    }],
    staticClass: "form-control",
    attrs: {
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.choosenMethods = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.allMethods), function(value, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(value.name + ' [' + value.altName + ']'))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-1"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle add-property",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.addOrRemoveMethod
    }
  })]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  }), _c('br', {
    attrs: {
      "clear": "all"
    }
  }), _c('br'), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMethodsTable),
      expression: "showMethodsTable"
    }],
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.methods), function(value, eachOption) {
    return _c('tr', {
      key: eachOption
    }, [_c('td', [_vm._v(_vm._s(eachOption))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(value.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(value.methods))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-times-circle",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.deleteMethodOption(eachOption, _vm.methods)
        }
      }
    })])])
  }))]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  }), _c('br', {
    attrs: {
      "clear": "all"
    }
  }), _c('br')]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Text Message(s)")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "english"
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textMessage.eng),
      expression: "textMessage.eng"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "id": "english",
      "placeholder": "English message"
    },
    domProps: {
      "value": (_vm.textMessage.eng)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textMessage.eng = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "swahili"
    }
  }, [_vm._v("Swahili")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.textMessage.swa),
      expression: "textMessage.swa"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "id": "swahili",
      "placeholder": "Swahili message"
    },
    domProps: {
      "value": (_vm.textMessage.swa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textMessage.swa = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "property"
    }
  }, [_vm._v("Property")]), _vm._v(" "), _c('div', {
    staticClass: "two-fields"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.property.type),
      expression: "property.type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "property"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.property.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getPropertyKeys('text', _vm.property.type)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("No Property")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "account"
    }
  }, [_vm._v("Account")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "session"
    }
  }, [_vm._v("Session")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.property.key),
      expression: "property.key"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "property-key"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.property.key = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("No Key")]), _vm._v(" "), _vm._l((_vm.propertyKeys.text), function(each, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": each.value
      }
    }, [_vm._v(_vm._s(each.name))])
  })], 2), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-circle add-property",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.addProperty
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [(_vm.textMessage.properties.length) ? _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.textMessage.properties), function(aProperty, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(aProperty.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(aProperty.key))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-times-circle",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.deleteProperty(index)
        }
      }
    })])])
  }))]) : _vm._e()]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "action-button"
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": "Add Message"
    },
    on: {
      "click": function($event) {
        _vm.addMessage()
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.allMessages.length) ? _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.allMessages), function(message, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(message.eng))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(message.swa))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(message.properties))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-times-circle",
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.deleteMessage(index)
        }
      }
    })])])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "action-button"
  }, [_c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "value": _vm.caption
    },
    on: {
      "click": function($event) {
        _vm.addStage()
      }
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Option")]), _vm._v(" "), _c('th', [_vm._v("Action")]), _vm._v(" "), _c('th', [_vm._v("Methods")]), _vm._v(" "), _c('th')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Property")]), _vm._v(" "), _c('th', [_vm._v("Key")]), _vm._v(" "), _c('th', [_vm._v("Delete")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("English")]), _vm._v(" "), _c('th', [_vm._v("Swahili")]), _vm._v(" "), _c('th', [_vm._v("Properties")]), _vm._v(" "), _c('th', [_vm._v("Delete")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2c3d95d5","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateSmsApp/stage.vue
// module id = HjGF
// module chunks = 1